import type { ChainModifiers, Entry, EntrySkeletonType, LocaleCode } from 'contentful';
import type * as Contentful from '~/services/origins/contentful';

export function isComponentForm<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentForm<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentForm';
}

export function isComponentFormBehaviorDownload<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormBehaviorDownload<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormBehaviorDownload';
}

export function isComponentFormBehaviorRedirect<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormBehaviorRedirect<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormBehaviorRedirect';
}

export function isComponentFormFieldOptionCheckbox<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldOptionCheckbox<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldOptionCheckbox';
}

export function isComponentFormFieldOptionRadio<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldOptionRadio<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldOptionRadio';
}

export function isComponentFormFieldOptionSelect<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldOptionSelect<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldOptionSelect';
}

export function isComponentFormFieldTypeCheckbox<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldTypeCheckbox<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldTypeCheckbox';
}

export function isComponentFormFieldTypeHidden<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldTypeHidden<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldTypeHidden';
}

export function isComponentFormFieldTypeRadio<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldTypeRadio<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldTypeRadio';
}

export function isComponentFormFieldTypeSelect<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldTypeSelect<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldTypeSelect';
}

export function isComponentFormFieldTypeText<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldTypeText<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldTypeText';
}

export function isComponentFormFieldTypeTextarea<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormFieldTypeTextarea<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormFieldTypeTextarea';
}

export function isComponentFormStep<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is Contentful.ComponentFormStep<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentFormStep';
}
